import { make } from 'vuex-pathify'

const state = {
  drawer: null,
  userPermissions: {},
  owner: null,
  errors: null,
}

const mutations = make.mutations(state)

const getters = {}

const actions = {}

export const app = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
